export default "__VITE_ASSET__8sVOW3nU__"